<template>
    <div class="ppv2-space-y-4">
        <InfoMessageBox class="ppv2-mt-2" :title="$t('messageBox.bankDetails.start.title')" color="info" />
        <div class="ppv2-flex ppv2-flex-col ppv2-space-y-4">
            <BaseInput
                v-model="formData.format_numeration"
                :label="$t('bankDetails.fields.bankingInstitution.label')"
                :placeholder="$t('bankDetails.fields.bankingInstitution.placeholder')"
                :tooltipMsg="$t('bankDetails.fields.bankingInstitution.infoMessage')"
                required
            >
                <template #leftIcon>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 9.5H20M4 15.5H20M10 3.5L8 21.5M16 3.5L14 21.5"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </template>
            </BaseInput>
            <BaseInput
                v-model="formData.bank_name"
                :label="$t('bankDetails.fields.accountName.label')"
                :placeholder="$t('bankDetails.fields.accountName.placeholder')"
                :tooltipMsg="$t('bankDetails.fields.accountName.infoMessage')"
                required
            >
                <template #leftIcon>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 9.5H20M4 15.5H20M10 3.5L8 21.5M16 3.5L14 21.5"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </template>
            </BaseInput>
            <BaseInput
                v-model="formData.iban"
                :label="$t('bankDetails.fields.iban.label')"
                :placeholder="$t('bankDetails.fields.iban.placeholder')"
                :tooltipMsg="$t('bankDetails.fields.iban.infoMessage')"
                required
            >
                <template #leftIcon>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 9.5H20M4 15.5H20M10 3.5L8 21.5M16 3.5L14 21.5"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </template>
            </BaseInput>
            <BaseInput
                v-model="formData.swift"
                :label="$t('bankDetails.fields.bic.label')"
                :placeholder="$t('bankDetails.fields.bic.placeholder')"
                :tooltipMsg="$t('bankDetails.fields.bic.infoMessage')"
                required
            >
                <template #leftIcon>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 9.5H20M4 15.5H20M10 3.5L8 21.5M16 3.5L14 21.5"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </template>
            </BaseInput>
            <BaseCheckbox
                v-model="formData.is_certify"
                :label="$t('bankDetails.fields.options.accurateInformation.label')"
                class="ppv2-mt-4"
            />
        </div>
    </div>
</template>

<script>
import InfoMessageBox from '../../../Shared/InfoMessageBox.vue'
import BaseInput from '../../../Shared/BaseInput.vue'
import BaseCheckbox from '../../../Shared/BaseCheckbox.vue'

export default {
    name: 'BankDetails',
    components: {
        InfoMessageBox,
        BaseInput,
        BaseCheckbox,
    },
    data() {
        return {
            formData: {
                iban: '',
                swift: '',
                format_numeration: '',
                bank_name: '',
                is_certify: false,
            },
        }
    },
    computed: {
        establishment() {
            return this.$store.getters['establishment/establishment']
        },
    },
    watch: {
        establishment: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        formData: {
            handler(newVal) {
                this.$emit('update', newVal)
            },
            deep: true,
        },
    },
    methods: {
        initializeForm() {
            const fields = ['iban', 'swift', 'format_numeration', 'bank_name', 'is_certify']
            fields.forEach((field) => {
                if (this.establishment.hasOwnProperty(field)) {
                    this.formData[field] = this.establishment[field]
                }
            })
        },
    },
}
</script>

<style scoped></style>
